import React, { useState, useEffect } from "react";
import Members from "../../../../Components/Icons/Member";

const NewManpower = () => {
  // Dummy data for testing
  const dummyManPower = [
    { designation: "Project Manager", count: 5 },
    { designation: "Team Lead", count: 8 },
    { designation: "Engineer", count: 25 },
    // { designation: "UI/UX Designer", count: 6 },
    // { designation: "Quality Analyst", count: 7 },
    // { designation: "DevOps Engineer", count: 4 },
  ];

  const dummyManPowerCount = dummyManPower.reduce((total, item) => total + item.count, 0);

  const [manPower, setManPower] = useState([]);
  const [manPowerCount, setManPowerCount] = useState(0);

  // Simulate API call with dummy data
  const getAllManpower = () => {
    // Simulating an API call delay with setTimeout
    setTimeout(() => {
      setManPower(dummyManPower);
      setManPowerCount(dummyManPowerCount);
    }, 1000); // Delay of 1 second for simulation
  };

  useEffect(() => {
    getAllManpower();
  }, []);

  return (
    <div className="bg-white rounded-lg drop-shadow-lg h-[45vh] 2xl:h-[35vh] w-full">
      {/* Header */}
      <div className="bg-[#ECEBF3] h-12 justify-between px-10 w-full flex py-3">
        <div className="flex gap-4 text-center justify-start">
          <div>
        <svg width="30" height="25" viewBox="0 0 43 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M30.9181 29C30.9181 29.5523 31.3658 30 31.9181 30C32.4704 30 32.9181 29.5523 32.9181 29H30.9181ZM9.67327 29C9.67327 29.5523 10.121 30 10.6733 30C11.2256 30 11.6733 29.5523 11.6733 29H9.67327ZM35.3376 21.2087V20.2087C34.7896 20.2087 34.3437 20.6497 34.3376 21.1977C34.3316 21.7456 34.7676 22.1964 35.3155 22.2085L35.3376 21.2087ZM34.7326 8.52174C34.1803 8.52174 33.7326 8.96945 33.7326 9.52174C33.7326 10.074 34.1803 10.5217 34.7326 10.5217V8.52174ZM40.9504 29C40.9504 29.5523 41.3982 30 41.9504 30C42.5027 30 42.9504 29.5523 42.9504 29H40.9504ZM7.66203 21.2087L7.6841 22.2085C8.23195 22.1964 8.66802 21.7456 8.66197 21.1977C8.65592 20.6497 8.21001 20.2087 7.66203 20.2087V21.2087ZM8.26736 10.5217C8.81965 10.5217 9.26736 10.074 9.26736 9.52174C9.26736 8.96945 8.81965 8.52174 8.26736 8.52174V10.5217ZM0.0495534 29C0.0495534 29.5523 0.497269 30 1.04955 30C1.60184 30 2.04955 29.5523 2.04955 29H0.0495534ZM28.2625 9.4C28.2625 13.5375 25.0941 16.8 21.2957 16.8V18.8C26.2972 18.8 30.2625 14.5409 30.2625 9.4H28.2625ZM21.2957 16.8C17.4972 16.8 14.3289 13.5375 14.3289 9.4H12.3289C12.3289 14.5409 16.2942 18.8 21.2957 18.8V16.8ZM14.3289 9.4C14.3289 5.26254 17.4972 2 21.2957 2V0C16.2942 0 12.3289 4.25907 12.3289 9.4H14.3289ZM21.2957 2C25.0941 2 28.2625 5.26254 28.2625 9.4H30.2625C30.2625 4.25907 26.2972 0 21.2957 0V2ZM11.6733 29C11.6733 27.4385 11.6747 26.0304 11.8317 24.7634C11.9877 23.5034 12.2897 22.4647 12.8375 21.6284C13.8841 20.0308 16.0963 18.8 21.2957 18.8V16.8C15.8726 16.8 12.7736 18.0764 11.1646 20.5324C10.3847 21.7229 10.0227 23.0976 9.84683 24.5175C9.67182 25.9304 9.67327 27.4687 9.67327 29H11.6733ZM21.2728 18.7997C26.4843 18.9192 28.7077 20.1469 29.7577 21.7255C30.3036 22.5463 30.6043 23.561 30.7599 24.7994C30.9166 26.0462 30.9181 27.4379 30.9181 29H32.9181C32.9181 27.4693 32.9196 25.945 32.7443 24.55C32.568 23.1466 32.2049 21.7935 31.423 20.6179C29.8173 18.2038 26.7295 16.9243 21.3186 16.8003L21.2728 18.7997ZM39.0325 15.3652C39.0325 16.8395 38.6837 18.0705 38.0707 18.9053C37.4856 19.702 36.6134 20.2087 35.3376 20.2087V22.2087C37.2395 22.2087 38.7147 21.4073 39.6827 20.0891C40.6228 18.8089 41.0325 17.1182 41.0325 15.3652H39.0325ZM34.7326 10.5217C37.2392 10.5217 39.0325 12.5633 39.0325 15.3652H41.0325C41.0325 11.7126 38.5816 8.52174 34.7326 8.52174V10.5217ZM35.3155 22.2085C39.0911 22.2918 40.2016 23.1516 40.6264 24.0014C40.8731 24.4948 40.9767 25.1385 40.9963 26.0135C41.0059 26.4447 40.9953 26.9048 40.9813 27.409C40.9675 27.9059 40.9504 28.4449 40.9504 29H42.9504C42.9504 28.4793 42.9664 27.9733 42.9806 27.4645C42.9945 26.9628 43.0067 26.4563 42.9958 25.9687C42.9742 25.0059 42.863 24.0025 42.4154 23.1071C41.4517 21.1794 39.2557 20.295 35.3596 20.2089L35.3155 22.2085ZM1.96749 15.3652C1.96749 17.1181 2.37712 18.8089 3.31704 20.089C4.28496 21.4073 5.76008 22.2087 7.66203 22.2087V20.2087C6.38623 20.2087 5.51409 19.702 4.92917 18.9053C4.31626 18.0706 3.96749 16.8396 3.96749 15.3652H1.96749ZM8.26736 8.52174C4.4184 8.52174 1.96749 11.7126 1.96749 15.3652H3.96749C3.96749 12.5633 5.76083 10.5217 8.26736 10.5217V8.52174ZM7.63996 20.2089C3.74386 20.295 1.54796 21.1793 0.584394 23.1071C0.13686 24.0025 0.0257077 25.0059 0.00416225 25.9687C-0.0067507 26.4564 0.0054611 26.9629 0.0194075 27.4645C0.0335525 27.9733 0.0495534 28.4793 0.0495534 29H2.04955C2.04955 28.4449 2.03245 27.9059 2.01864 27.4089C2.00462 26.9048 1.99401 26.4447 2.00366 26.0135C2.02324 25.1384 2.12676 24.4947 2.37337 24.0013C2.79811 23.1516 3.90844 22.2918 7.6841 22.2085L7.63996 20.2089Z" fill="#119DEE"/>
</svg>
</div>
          <h2 className="font-semibold text-[#4F4768] text-sm">Manpower</h2>
        </div>
        <p className="font-semibold text-[14px] text-center text-[#333]">
          {`${manPowerCount || 0}`}
        </p>
      </div>

      {/* Body */}
      <div className="w-[80%] mx-auto text-center pt-1 p-4">
        <div className="h-[25vh] w-full p-1 overflow-y-auto">
          {manPower &&
            manPower.map((item, idx) => (
              <div
                className="flex items-center my-2 justify-between"
                key={idx}
              >
                <div className="w-[60%] text-justify">
                  <p className="text-xs text-[#707987] font-medium">
                    {item?.designation || "-"}
                  </p>
                </div>
                <div className="w-[40%] text-center">
                  <p className="text-xs text-[#707987] font-medium">
                    : <span className="">{item?.count || 0}</span>
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default NewManpower;
